exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pagination.controls{display:flex;justify-content:center;align-items:center;color:#6b6d6b;padding-bottom:10px}@media (max-width: 400px){.pagination.controls{padding-bottom:1%}}.pagination.controls .control .icon.btn{font-size:225%}.pagination.controls .control .digit.btn{background-color:transparent;border-radius:50%;color:#fff;width:36px;height:36px;font-size:100%;display:flex;justify-content:center;align-items:center;cursor:pointer;font-family:\"sf_ui_displayregular\"}.pagination.controls .control.disabled{opacity:0.3;cursor:default}.pagination.controls .control .digit.btn:hover,.pagination.controls .control .digit.btn.active{background-color:#6b6d6b}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pagination/style.scss
// module id = 495
// module chunks = 0